module.exports = __webpack_public_path__ + "static/img/mouth_04.206261d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/mouths/thumbnail/mouth_04.png
// module id = 3kHo
// module chunks = 0